import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Headers,Response, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';

let tokenUrl = 'http://windaapi.herokuapp.com/o/token/';
let usertypeUrl = 'http://windaapi.herokuapp.com/api/v1/user-type/';
let shopsUrl = 'http://windaapi.herokuapp.com/api/v1/shops/';
let mallsUrl = 'http://windaapi.herokuapp.com/api/v1/malls/';

@Injectable()
export class AuthService {

  private redirectUrl:string ='/';
  private loginUrl:string="/login";
  private isloggedIn: boolean = false;

  private isShopLoggedIn: boolean =false;
  private isMallLoggedIn: boolean =false;
  private isAdminLoggedIn: boolean =false;


  getToken(username: string, password: string) {
    var headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('client_id', 'MiEVA2QR5u7hacL4GA5urQxQ9WUn9y79rQJoiLu6');
    urlSearchParams.append('username', username);
    urlSearchParams.append('password', password);
    urlSearchParams.append('grant_type', 'password');
    let body = urlSearchParams.toString()
    return this.http.post(tokenUrl, body, {headers: headers})
    .map(res => res.json())
    .catch(this.error)
}
 
  authenticate(token:string){
    var headers = new Headers();
    headers.append('Authorization', 'Bearer ' + token);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.get(usertypeUrl, {headers: headers})
    .map(res =>  res.json())
    .catch(this.error)   
   }

  getProfile(token:string){
    var headers = new Headers();
    headers.append('Authorization', 'Bearer ' + token);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.get(usertypeUrl, {headers: headers})
    .map(res => res.json())
    .catch(this.error)
  }

  userType(usertype:string){
    if(usertype === 'shop'){
      this.isShopLoggedIn = true 
    }else{
      this.isShopLoggedIn = false
    } 
    if(usertype === 'mall'){
       this.isMallLoggedIn = true
    }else {
       this.isMallLoggedIn =false
    } 
    if(usertype == 'admin'){
      this.isAdminLoggedIn = true
    }else {
      this.isAdminLoggedIn =false
    }
  }

  addShop(shop){
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http.post(shopsUrl ,shop ,{headers: headers})
    .map(res => res.json())
    .catch(error => error.json())
  }
  
  addMall(mall){
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http.post(mallsUrl ,mall ,{headers: headers})
    .map(res => res.json())
    .catch(error => error.json())
  }

  isUserLoggedIn(): boolean{
    if(localStorage.getItem("userData")){
      this.isloggedIn = true
      if(localStorage.getItem("USER-TYPE") === 'shop'){
        this.isShopLoggedIn = true 
      }else{
        this.isShopLoggedIn = false
      } 
      if(localStorage.getItem("USER-TYPE") === 'mall'){
         this.isMallLoggedIn = true
      }else {
         this.isMallLoggedIn =false
      } 
      if(localStorage.getItem("USER-TYPE") == 'admin'){
        this.isAdminLoggedIn = true
      }else {
        this.isAdminLoggedIn =false
      }
    }else{
      this.isloggedIn =false
    }
     return this.isloggedIn;
  }

  isUserShop():boolean{
     return this.isShopLoggedIn;
  }
  isUserMall():boolean{
    return this.isMallLoggedIn;
 }
 isUserAdmin():boolean{
  return this.isAdminLoggedIn;
}
  
  getRedirectUrl(): string{
    return this.redirectUrl;
  }
  setRedirectUrl(url:string):void{
    this.redirectUrl = url;
  }
  getLoginUrl(): string{
    return this.loginUrl;
  }

  logoutUser():void{
    this.isloggedIn = false;
    localStorage.removeItem('userData');
    localStorage.removeItem('tokenData');
    localStorage.removeItem('access_token')
    localStorage.removeItem('USER');
    localStorage.removeItem('USER-TYPE');
  }

  constructor( private http: Http) {   }

   private error(error: any) {
    //console.log("This is ", error);
    if (!error.url) {
      return Observable.throw("No internet Connection ");
    }
    else if (error.status == 401) {
      return Observable.throw("Invalid Credentials");
    }
    else if (error.status == 400) {
      return Observable.throw("Missing Password or Username");
    }
    else {
      return Observable.throw(error.json() || "Error ")
    }
    //  this.error(error);
    // this.presentAlert("Observable Api Error", JSON.stringify(error));

  }
}




// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/services/auth.service.ts